import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";


const ProtectedRoute = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    // Initialize isLoggedIn based on localStorage value
    return !!localStorage.getItem("authToken");
  });

  const location = useLocation();
  const hideMenuRoutes = ["/login"];

  useEffect(() => {
    // Check login status on mount (useful if there's a need for API verification)
    const authToken = localStorage.getItem("authToken");
    setIsLoggedIn(!!authToken);
  }, []);
 
  return isLoggedIn ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
